import { defineMessages } from 'react-intl';

const metricMessages = defineMessages({
  bank: { id: 'common.bank', defaultMessage: 'Bank' },
  costOfSales: { id: 'financial_fields.category.cost_of_sales', defaultMessage: 'Cost of Sales' },
  expenses: { id: 'financial_fields.category.expenses', defaultMessage: 'Expenses' },
  grossProfit: { id: 'predict.gross_profit', defaultMessage: 'Gross profit' },
  netCashFlow: { id: 'predict.net_cash_flow', defaultMessage: 'Net cash flow' },
  netProfit: { id: 'predict.net_profit', defaultMessage: 'Net profit' },
  sales: { id: 'financial_fields.category.sales', defaultMessage: 'Sales' }
});

export const PERFORMANCE_COMPARISON_FILTERS_LOCAL_STORAGE_KEY = 'performance-comparison-filters';

export const PERFORMANCE_COMPARISON_METRICS = [
  { id: 'v2:static:income:transactional', message: metricMessages.sales },
  { id: 'v2:static:cost_of_sales:transactional', message: metricMessages.costOfSales },
  { id: 'v2:static:gross_profit:transactional', message: metricMessages.grossProfit },
  { id: 'v2:static:expenses:transactional', message: metricMessages.expenses },
  { id: 'v2:static:net_profit:transactional', message: metricMessages.netProfit },
  { id: 'v2:static:bank_accounts:cumulative', message: metricMessages.bank },
  { id: 'v2:static:net_cash_flow:cash_transactional', message: metricMessages.netCashFlow }
] as const;

export type PerformanceComparisonMetricId = typeof PERFORMANCE_COMPARISON_METRICS[number]['id'];

export const DEFAULT_PERFORMANCE_COMPARISON_METRIC_ID: PerformanceComparisonMetricId =
  PERFORMANCE_COMPARISON_METRICS[0].id;

export const normalizePerformanceComparisonMetric = (metricId?: string): PerformanceComparisonMetricId => {
  const metric = PERFORMANCE_COMPARISON_METRICS.find(({ id }) => id === metricId);
  return metric?.id ?? DEFAULT_PERFORMANCE_COMPARISON_METRIC_ID;
};
